import { Button } from '@/components/button';
import { FormLabel } from '@/components/form/formlabel';
import { Input } from '@/components/form/input';
import {
  clearErrors,
  getLoginGoogle,
  loginGoogleCallback,
  register,
} from '@/reducers/auth';
import { AppDispatch } from '@/root/store';
import { CheckIcon } from '@heroicons/react/24/solid';
import 'primeicons/primeicons.css';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

export function Register() {
  const [searchParams] = useSearchParams();
  const code = searchParams.get('code');
  const scope = searchParams.get('scope');
  const authUser = searchParams.get('authuser');
  const prompt = searchParams.get('prompt');

  const dispatch: AppDispatch = useDispatch();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    username: '',
    password: '',
  });

  const { loading, errors } = useSelector((state: any) => state.auth);

  useEffect(() => {
    if (code) {
      dispatch(loginGoogleCallback(code, scope, authUser, prompt));
    }
  }, [code, scope, authUser, prompt, dispatch]);

  const loginGoogleSubmit = () => {
    dispatch(getLoginGoogle());
  };

  const submit = (e: any) => {
    e.preventDefault();

    dispatch(register(formData));
  };

  const setData = (e: any, element: string) => {
    setFormData({ ...formData, [element]: e.target.value });

    dispatch(clearErrors());
  };

  return (
    <>
      <div className='text-900 mb-1 text-3xl font-medium'>
        Selamat datang! 👋🏻
      </div>
      <p className={'text-400 mb-4'}>
        Buat akun biar bisa kamu segera jual tiket
      </p>
      <form onSubmit={submit}>
        <div>
          <div className='mb-3'>
            <FormLabel
              label='Nama Penyelenggara'
              errorText={errors.name}
              required
            >
              <Input
                type='text'
                onChange={(e) => setData(e, 'name')}
                required
              />
            </FormLabel>
          </div>
          <div className='mb-3 lg:col-span-2'>
            <FormLabel label='Username' errorText={errors.username} required>
              <Input
                type='text'
                onChange={(e) => setData(e, 'username')}
                required
              />
            </FormLabel>
          </div>
          <div className='mb-3'>
            <FormLabel label='Email' errorText={errors.email} required>
              <Input
                type='email'
                onChange={(e) => setData(e, 'email')}
                required
              />
            </FormLabel>
          </div>
          <div className='mb-3'>
            <FormLabel label='Password' errorText={errors.password} required>
              <Input
                type='password'
                onChange={(e) => setData(e, 'password')}
                required
              />
            </FormLabel>
          </div>
          <div className='align-items-center justify-content-between mb-6 flex'>
            <div className='align-items-center flex'>
              <CheckIcon className={'mr-2 w-8'} />
              <small>
                Dengan mendaftar, saya berarti telah menyetujui seluruh{' '}
                <a
                  target={'_blank'}
                  rel='noreferrer'
                  href={'https://tokoevent.id/syarat-ketentuan'}
                  className={'font-semibold underline'}
                >
                  syarat dan ketentuan
                </a>{' '}
                yang berlaku
              </small>
            </div>
          </div>
          <div>
            <Button
              loading={loading === 'manual'}
              className={'w-full'}
              color='neutral'
              leftIcon={<CheckIcon />}
            >
              Daftar
            </Button>
            <Button
              loading={loading === 'google'}
              onClick={loginGoogleSubmit}
              variant={'neutral'}
              look={'outline'}
              className={'mt-2 w-full'}
              color='neutral'
              leftIcon={<i className='pi pi-google'></i>}
            >
              Daftar dengan Google
            </Button>
          </div>
        </div>
      </form>
      <div className={'mt-4 text-center'}>
        <span className='text-600 line-height-3 font-medium'>
          Sudah punya akun?
        </span>{' '}
        <a href={'login'} className={'font-semibold underline'}>
          Login yuk!
        </a>
      </div>
    </>
  );
}
